import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { configurationSubject } from 'src/app/environment-resolver';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  toggleMode = 'over';
  isActive = false;
  isActiveSearch = false;
  userName = '';
  loginOptions = '';
  isInValidUserName = false;
  megaSearch = '';
  page = '/';
  constructor(private location: Location, private router: Router) {
    router.events.subscribe(() => {
      if (this.location.path() !== '/' &&  this.router.parseUrl(this.location.path()) &&  this.router.parseUrl(this.location.path()).root &&  this.router.parseUrl(this.location.path()).root.children &&  this.router.parseUrl(this.location.path()).root.children['primary'] &&  this.router.parseUrl(this.location.path()).root.children['primary'].segments) {
        this.page = this.router.parseUrl(this.location.path()).root.children['primary'].segments.map(it => it.path).join('/');
      }
    });
  }

  @Output() drawerToggleOutput = new EventEmitter();

  ngOnInit() {}
  onChangeOption(event) {
    event.stopPropagation();
    this.isInValidUserName = false;
  }

  validateLogin() {
    const env = configurationSubject.getValue().environment;
    if (this.userName && this.userName.trim() !== '') {
      this.isInValidUserName = false;
      let _url = 'https://mcnet.upmchp.com/memberportal/#/login-with?login_hint=' +
        encodeURIComponent(this.userName);
      if (this.loginOptions === 'providers') {
        _url = 'https://upmchealthplan.upmc.com/Login/Login.aspx?CLIENT=000001&ID=000001&DIV=0001';
      } else if (this.loginOptions === 'employers') {
        if (env == 'dev') {
          _url = 'https://upmchealthplantst.upmc.com/Employer/Home.aspx?login_hint=' + encodeURIComponent(this.userName);
        } else if (env == 'tst') {
          _url = 'https://upmchealthplantst.upmc.com/Employer/Home.aspx?login_hint=' + encodeURIComponent(this.userName);
        } else {
          _url = 'https://upmchealthplan.upmc.com/Employer/Home.aspx?login_hint=' + encodeURIComponent(this.userName);
        }
      } else if (this.loginOptions === 'producers') {
        if (env == 'dev') {
          _url = 'https://salesportaldev.upmchp.com/portal/Home.aspx?login_hint=' + encodeURIComponent(this.userName);
        } else if (env == 'tst') {
          _url = 'https://salesportaltst.upmchp.com/portal/home.aspx?login_hint=' + encodeURIComponent(this.userName);
        } else {
          _url = 'https://www.upmchpsalesportal.com/Portal/Home.aspx?login_hint=' + encodeURIComponent(this.userName);
        }
      }
      window.open(_url, '_self');
    } else {
      this.isInValidUserName = true;
    }
  }

  validateSearch() {
    const url = 'https://www.upmchealthplan.com/search.aspx#?cludoquery=' + this.megaSearch;
    window.location.href = url;
  }

  setLoginMouseover(event) {
    this.isActive = event;
  }

  drawerToggle() {
    this.drawerToggleOutput.emit(true);
  }
  onClickSearch() {
    this.isActiveSearch = !this.isActiveSearch;
  }
}
